// Constructor
// file is a SWFUpload file object
// targetID is the HTML element id attribute that the RamJetFileProgress HTML structure will be added to.
function RamJetFileProgress(file, targetID, width) {
	this.fileProgressID = file.id;
	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		"/": '&#x2F;',
	};
	var reg = /[&<>"'/]/ig;
	this.fileName = file.name.replace(reg, (match)=>(map[match]));

	this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
	if (this.fileProgressWrapper.length == 0) {
		var progressHtml = "";
		progressHtml = progressHtml + '<div class="ramJetProgressWrapper" id="' + this.fileProgressID + '">';
		progressHtml = progressHtml + '<div class="progressContainer">';
		progressHtml = progressHtml + '<a href="#" class="progressCancel" style="display: none;"> </a>';
		progressHtml = progressHtml + '<div class="progressName">' + this.fileName + '</div>';
		progressHtml = progressHtml + '<div class="progressBar progressBarInProgress"/>';
		progressHtml = progressHtml + '<div class="progressBarStatus">&nbsp;</div>';
		progressHtml = progressHtml + '</div>';
		progressHtml = progressHtml + '</div>';
		var jProgressHtml = jQuery(progressHtml);
		if (width !== null && width !== undefined) {
			jProgressHtml.css("width", width);
		}
		jProgressHtml.insertBefore("#" + targetID);
		this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
	}
	this.fileProgressElement = this.fileProgressWrapper.children(".progressContainer");
	this.fileProgressElement.find(".progressName").html(this.fileName);
}

RamJetFileProgress.prototype.setProgress = function (percentage) {
	this.fileProgressElement.attr("class", "progressContainer green");
	this.fileProgressElement.children(".progressBar")
		.attr("class", "progressBar progressBarInProgress")
		.css("width", percentage + "%");
};
RamJetFileProgress.prototype.setComplete = function (ms) {
	this.appear();
	ms = ms !== undefined ? ms : 10000;
	this.fileProgressElement.attr("class", "progressContainer blue");
	this.fileProgressElement.children(".progressBar")
		.attr("class", "progressBar progressBarComplete")
		.css("width", "");

	var oSelf = this;
	if (ms > 0) {
		setTimeout(function () {
			oSelf.disappear();
		}, ms);
	}
};
RamJetFileProgress.prototype.setError = function (ms) {
	this.appear();
	ms = ms !== undefined ? ms : 5000;

	this.fileProgressElement.attr("class", "progressContainer red");
	this.fileProgressElement.children(".progressBar")
		.attr("class", "progressBar progressBarError")
		.css("width", "");

	var oSelf = this;
	var cancelBtn = this.fileProgressElement.find(".progressCancel");
	cancelBtn.show();
	cancelBtn.click(function () {
		oSelf.disappear();
		return false;
	});
	if (ms > 0) {
		setTimeout(function () {
			oSelf.disappear();
		}, ms);
	}
};

RamJetFileProgress.prototype.setCancelled = function (ms) {
	ms = ms || 2000;
	this.appear();

	this.fileProgressElement.attr("class", "progressContainer red");
	this.fileProgressElement.children(".progressBar")
		.attr("class", "progressBar progressBarError")
		.css("width", "");

	var oSelf = this;
	setTimeout(function () {
		oSelf.disappear();
	}, ms);
};
RamJetFileProgress.prototype.setStatus = function (status) {
	this.fileProgressElement.find(".progressBarStatus").html(status);
};

RamJetFileProgress.prototype.setLabel = function(label) {
	this.fileProgressElement.find(".progressName").html(label);
}

// Show/Hide the cancel button
RamJetFileProgress.prototype.toggleCancel = function (show, swfUploadInstance) {
	var cancelBtn = this.fileProgressElement.find(".progressCancel");
	if (show) {
		cancelBtn.show();
	} else {
		// cancelBtn.hide();
	}
	if (swfUploadInstance) {
		var fileID = this.fileProgressID;
		cancelBtn.click(function () {
			swfUploadInstance.cancelUpload(fileID);
			return false;
		});
	}
};

// Makes sure the RamJetFileProgress box is visible
RamJetFileProgress.prototype.appear = function () {
	this.fileProgressWrapper.show("slow");
};

// Fades out and clips away the RamJetFileProgress box.
RamJetFileProgress.prototype.disappear = function () {
	var wrapperToRemove = this.fileProgressWrapper;
	this.fileProgressWrapper.hide("slow", function() {wrapperToRemove.remove()});
};

module.exports = RamJetFileProgress;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/plUpload/fileProgressBar.js